import { Modal } from '../../../../components/shared';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import { MODAL_CONFIG } from '../../constants';

const LoadingModal = ({ isOpen }) => (
  <Modal open={isOpen} customWidth={MODAL_CONFIG.LOADING_WIDTH}>
    <LoadingSpinner containerHeight={MODAL_CONFIG.LOADING_SPINNER_HEIGHT} />
  </Modal>
);

export default LoadingModal;
